import { i18n } from '@/plugins/i18n';

const t = i18n.global.t;

export function getKeyDashboardMetrics(
  data: { pageviews: number; visitors: number; visits: number; bounces: number; totaltime: number }[],
) {
  return data.reduce(
    (totals, entry) => {
      totals.pageviews += entry.pageviews;
      totals.visitors += entry.visitors;
      totals.visits += entry.visits;
      totals.bounces += entry.bounces;
      totals.totaltime += entry.totaltime;
      return totals;
    },
    { pageviews: 0, visitors: 0, visits: 0, bounces: 0, totaltime: 0 }, // initial values for totals
  );
}

export function getVisitorsSeries(data: { visitors: number }[]): number[] {
  return data.map((entry) => entry.visitors);
}

export function getWeeklyViewsChartOptions(data: object) {
  function getDates(data: { date: string }[]): string[] {
    return data.map((entry) => entry.date);
  }

  return {
    chart: {
      type: 'bar',
      height: 300,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: false,
        columnWidth: '55%',
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -30,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    grid: {
      row: {
        colors: ['#fff', '#f2f2f2'],
      },
    },
    xaxis: {
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
      },
      categories: getDates(data),
      tickPlacement: 'on',
    },
    yaxis: [
      {
        max: (max: number) => {
          const multiplier = 1.2;
          const scaledMax = max * multiplier;
          const magnitude = Math.pow(10, Math.floor(Math.log10(scaledMax)));
          return Math.ceil(scaledMax / magnitude) * magnitude;
        },
        min: undefined,
        forceNiceScale: true,
        title: {
          text: t('dashboard.views-chart.x-axis'),
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter(val: number) {
          return `${val}`;
        },
      },
    },
  };
}
